// extracted by mini-css-extract-plugin
export default {"productGallery":"gM-z","inQuickShop":"hM-z"};